import React from 'react';
export const privacyContent = <>
    <p className="text-sm text-zinc-500" data-id="element-77">
      Última actualización: {new Date().getFullYear()}
    </p>
    <p data-id="element-78">
      En Chakra Reset valoramos y respetamos tu privacidad. Esta Política de
      Privacidad describe cómo recopilamos, utilizamos y protegemos la
      información relacionada con tu acceso y uso del producto digital "Chakra
      Reset: 7 Días de Desbloqueo".
    </p>
    <h3 className="text-lg font-bold text-zinc-200 pt-2" data-id="element-79">
      1. Información que recopilamos
    </h3>
    <p data-id="element-80">
      Recopilamos únicamente la información necesaria para procesar tu compra y
      otorgarte acceso inmediato al producto digital, como tu nombre y los datos
      de transacción gestionados de forma segura por nuestra plataforma de pago.
    </p>
    <h3 className="text-lg font-bold text-zinc-200 pt-2" data-id="element-81">
      2. Uso de la información
    </h3>
    <p data-id="element-82">
      Utilizamos tu información exclusivamente para entregarte el producto
      adquirido, brindarte acceso al contenido y mantener un registro de tu
      compra. No vendemos ni compartimos tu información personal con terceros
      con fines comerciales.
    </p>
    <h3 className="text-lg font-bold text-zinc-200 pt-2" data-id="element-83">
      3. Seguridad de los datos
    </h3>
    <p data-id="element-84">
      Implementamos medidas razonables para proteger tu información frente a
      accesos no autorizados. Los pagos se procesan a través de pasarelas
      seguras y cifradas.
    </p>
    <h3 className="text-lg font-bold text-zinc-200 pt-2" data-id="element-85">4. Cookies</h3>
    <p data-id="element-86">
      Este sitio puede utilizar cookies y tecnologías similares para mejorar tu
      experiencia de navegación y analizar el rendimiento del contenido.
    </p>
    <h3 className="text-lg font-bold text-zinc-200 pt-2" data-id="element-87">5. Tus derechos</h3>
    <p data-id="element-88">
      Tienes derecho a solicitar el acceso, la corrección o la eliminación de
      tus datos personales en cualquier momento, de acuerdo con la legislación
      aplicable.
    </p>
  </>;
export const termsContent = <>
    <p className="text-sm text-zinc-500" data-id="element-89">
      Última actualización: {new Date().getFullYear()}
    </p>
    <p data-id="element-90">
      Al adquirir y utilizar "Chakra Reset: 7 Días de Desbloqueo" aceptas los
      siguientes Términos y Condiciones. Te recomendamos leerlos detenidamente
      antes de realizar tu compra.
    </p>
    <h3 className="text-lg font-bold text-zinc-200 pt-2" data-id="element-91">
      1. Naturaleza del producto
    </h3>
    <p data-id="element-92">
      Chakra Reset es un producto digital de acceso inmediato. La compra te
      otorga una licencia personal e intransferible para utilizar el contenido
      con fines de desarrollo personal.
    </p>
    <h3 className="text-lg font-bold text-zinc-200 pt-2" data-id="element-93">2. Uso personal</h3>
    <p data-id="element-94">
      El contenido es para tu uso individual. Queda prohibida la reproducción,
      distribución, reventa o difusión total o parcial del material sin
      autorización expresa.
    </p>
    <h3 className="text-lg font-bold text-zinc-200 pt-2" data-id="element-95">
      3. Aviso de bienestar
    </h3>
    <p data-id="element-96">
      Este producto ofrece prácticas somáticas y de bienestar de carácter
      educativo. No constituye asesoramiento médico, psicológico ni terapéutico,
      ni sustituye la atención de un profesional de la salud. Realiza los
      ejercicios bajo tu propia responsabilidad.
    </p>
    <h3 className="text-lg font-bold text-zinc-200 pt-2" data-id="element-97">4. Resultados</h3>
    <p data-id="element-98">
      Los resultados pueden variar de una persona a otra y dependen del
      compromiso individual con la práctica. No garantizamos resultados
      específicos.
    </p>
    <h3 className="text-lg font-bold text-zinc-200 pt-2" data-id="element-99">5. Pagos</h3>
    <p data-id="element-100">
      El precio indicado corresponde a un pago único por el acceso al producto
      digital. Una vez otorgado el acceso al contenido, la naturaleza digital
      del producto puede limitar la posibilidad de reembolso.
    </p>
    <h3 className="text-lg font-bold text-zinc-200 pt-2" data-id="element-101">
      6. Propiedad intelectual
    </h3>
    <p data-id="element-102">
      Todo el contenido, marcas y materiales son propiedad de Chakra Reset y
      están protegidos por las leyes de propiedad intelectual aplicables.
    </p>
  </>;